// extracted by mini-css-extract-plugin
module.exports = {"container":"ImageWidget_container__a_Du4","btn":"ImageWidget_btn__2JhsY","photosCount":"ImageWidget_photosCount__1xQ1a"};